<div class="text-and-image-paragraph"
  [ngClass]="{ 'desktop': !mobile, 'mobile': mobile }">

  @if (loading) {
    <hpo-placeholder
    type="row"></hpo-placeholder>
  }

  @if (!loading) {
    <div class="text-and-image-paragraph__container">
      @if (mobile) {
        <a [href]="source"
          target="_blank"
          class="text-and-image-paragraph__link"
          [class.text-and-image-paragraph__link--reversed]="data.self.attributes.field_text_and_image_reverse">
          <figure>
            <img [src]="source"
              alt="Image"
              class="text-and-image-paragraph__image">
            @if (caption) {
              <figcaption>
                {{caption}}
              </figcaption>
            }
          </figure>
        </a>
      }
      @if (!mobile) {
        <div class="text-and-image-paragraph__link"
          [class.text-and-image-paragraph__link--reversed]="data.self.attributes.field_text_and_image_reverse">
          <figure>
            <img [src]="source"
              alt="Image"
              class="text-and-image-paragraph__image"
              (click)="openLightbox()">
            @if (caption) {
              <figcaption>
                {{caption}}
              </figcaption>
            }
          </figure>
        </div>
      }
    </div>
    <div [innerHTML]="sanitizedHtml"
      class="text-and-image-paragraph__content"
    [class.reversed]="data.self.attributes.field_text_and_image_reverse"></div>
  }

</div>